var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-container",
    [
      _c(
        "b-row",
        { staticClass: "justify-content-center" },
        [
          _c(
            "b-col",
            { attrs: { col: "", lg: "6" } },
            [
              _c("b-card", { attrs: { title: "Page introuvable..." } }, [
                _c("p", [
                  _vm._v(
                    "La page que vous tentez d'afficher n'existe pas ou plus."
                  ),
                ]),
              ]),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }